<mat-form-field *ngIf="filteredOptions$ | async as filteredOptions" appearance="fill" class="w-full">
  <input
    #input
    (keyup)="onAutocompleteKeyUp(input.value, clients)"
    [formControl]="asFormControl(control)"
    [matAutocomplete]="auto"
    matInput
    placeholder="Seleccionar cliente"
    type="text"
  />

  <mat-error *ngIf="asFormControl(control).errors?.matchRequired">
    Por favor, selecciona un cliente de la lista
  </mat-error>

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="getAutoCompleteDisplayValue"
    autoActiveFirstOption>
    <mat-option *ngFor="let option of filteredOptions" [value]="option">
      {{ option.name + ' ' + option.lastname1 + ' ' + option.lastname2 }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
